import { BENEFITS_KEY_OVERRIDES } from 'helpers/benefits-key-overrides'
import { convertKeysToPascalCase } from 'helpers/convertKeysToPascalCase'

// Trace-driven remap for GET /core/benefits — restores legacy PascalCase keys
// on benefit records that downstream enrollme code still reads.

const remapBenefitItem = (item) =>
  convertKeysToPascalCase(item, BENEFITS_KEY_OVERRIDES)

export const remapBenefitsGetResponse = (data) => ({
  Benefits: (data.benefits ?? data.Benefits ?? []).map(remapBenefitItem),
  WaivedBenefits: (data.waivedBenefits ?? data.WaivedBenefits ?? []).map(
    remapBenefitItem
  ),
})
